import { IRequesterInfo, KeyValuePair } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { toDrillPath } from '../drilldownModel'
import { IChatManagementDrilldown, IDrillSelection } from '../models'
import { addDealerType, DealerTypeFilter } from '../../ChatbotAnalytics/analyticsQuery'

export class GetChatbotManagementDetailApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/chatbot-reports/management/detail', requesterInfo })
  }

  /** Kesişimli detay (ADR-022 §1): yolun tüm adımları tek parametrede, sırayla gider. */
  public async getDetail(
    fromUtc: Date,
    toUtc: Date,
    path: Pick<IDrillSelection, 'dimension' | 'key'>[],
    includeTestDealers = false,
    dealerType?: DealerTypeFilter
  ): Promise<IChatManagementDrilldown> {
    const query = new KeyValuePair<string>()
    query.add('fromUtc', fromUtc.toISOString())
    query.add('toUtc', toUtc.toISOString())
    query.add('path', toDrillPath(path))
    query.add('includeTestDealers', String(includeTestDealers))
    addDealerType(query, dealerType)
    this.queryParams = query
    return await this.getAsync<IChatManagementDrilldown>()
  }
}
